module.exports = __webpack_public_path__ + "static/media/plum.39f12471.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/apple-watch/silver-aluminum-case/plum.jpeg
// module id = 2047
// module chunks = 0